import React, { useState, useEffect } from 'react';
import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns';

interface CountdownTimerProps {
  targetDate: Date;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      
      // If the target date is in the past, return all zeros
      if (targetDate <= now) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      // Calculate time differences
      const days = differenceInDays(targetDate, now);
      const hours = differenceInHours(targetDate, now) % 24;
      const minutes = differenceInMinutes(targetDate, now) % 60;
      const seconds = differenceInSeconds(targetDate, now) % 60;
      
      return { days, hours, minutes, seconds };
    };

    // Initial calculation
    setTimeLeft(calculateTimeLeft());
    
    // Set up interval to update the countdown
    const timerId = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    
    // Clean up interval on unmount
    return () => clearInterval(timerId);
  }, [targetDate]);

  return (
    <div className="flex flex-col items-center">
      <h3 className="text-lg md:text-xl font-playfair text-wedding-blue-800 mb-4">Contagem Regressiva</h3>
      <div className="flex space-x-4 md:space-x-6">
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-lg shadow-md flex items-center justify-center">
            <span className="text-2xl md:text-3xl font-semibold text-wedding-blue-700">{timeLeft.days}</span>
          </div>
          <span className="text-xs md:text-sm mt-2 text-gray-700">Dias</span>
        </div>
        
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-lg shadow-md flex items-center justify-center">
            <span className="text-2xl md:text-3xl font-semibold text-wedding-blue-700">{timeLeft.hours}</span>
          </div>
          <span className="text-xs md:text-sm mt-2 text-gray-700">Horas</span>
        </div>
        
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-lg shadow-md flex items-center justify-center">
            <span className="text-2xl md:text-3xl font-semibold text-wedding-blue-700">{timeLeft.minutes}</span>
          </div>
          <span className="text-xs md:text-sm mt-2 text-gray-700">Minutos</span>
        </div>
        
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-lg shadow-md flex items-center justify-center">
            <span className="text-2xl md:text-3xl font-semibold text-wedding-blue-700">{timeLeft.seconds}</span>
          </div>
          <span className="text-xs md:text-sm mt-2 text-gray-700">Segundos</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;